module.exports = __webpack_public_path__ + "media/3.40d69d88.mp3";